// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"519":"2fe9b4c7","994":"b62e35ec"}[chunkId] + ".chunk.css";
};